import React from 'react'
import PropTypes from 'prop-types'

const AllroundContainer = React.forwardRef(({ id, children, className, dataTrackingName }, ref) => {
  return (
    <div
      id={id}
      ref={ref}
      data-tracking-name={dataTrackingName}
      className={`grid grid-cols-4 600:grid-cols-8 840:grid-cols-12
        gap-16 760:gap-24 1000:gap-32 1920:gap-40
        px-16 760:px-24 1000:px-32 1440:px-112 1920:px-128
        w-full 1280:mx-auto
        ${className}
      `}
    >
      {children}
    </div>
  )
})

AllroundContainer.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  dataTrackingName: PropTypes.string,
}

AllroundContainer.defaultProps = {
  className: '',
  dataTrackingName: null,
}

export default AllroundContainer
